module.exports = __webpack_public_path__ + "img/case_moneymonk_portrait.80874481.jpg";